// ============================================================
// Lógica de presentación compartida entre la tarjeta y el detalle
// de un plato. Calcula el estado del plato respecto a los alérgenos
// que el usuario quiere evitar y los textos de aviso.
// ============================================================
import { UI, resolveAllergen } from './data'

// 'danger'  → contiene un alérgeno del usuario
// 'warning' → solo aparece como traza
// 'safe'    → no contiene ninguno (y el usuario tiene selección)
// 'neutral' → el usuario no ha seleccionado alérgenos
export function dishStatus(algIds, tzIds, mine) {
  if (!mine.length) return 'neutral'
  if (algIds.some(id => mine.includes(id))) return 'danger'
  if (tzIds.some(id => mine.includes(id))) return 'warning'
  return 'safe'
}

// Texto del banner de aviso según el estado.
export function bannerFor(status, algIds, tzIds, mine, locale, map) {
  const ui = UI[locale] || UI.es
  if (status === 'danger') {
    const names = algIds.filter(id => mine.includes(id)).map(id => resolveAllergen(id, locale, map).name)
    return `${ui.contieneAviso}: ${names.join(', ')}`
  }
  if (status === 'warning') {
    const names = tzIds.filter(id => mine.includes(id)).map(id => resolveAllergen(id, locale, map).name)
    return `${ui.trazasAviso}: ${names.join(', ')}`
  }
  if (status === 'safe') return ui.aptoAviso
  return ''
}
